"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var adPlacements_1 = require("../ads-growth/ads-service/config/adPlacements");
var adEligiblePaidStoryIds_1 = require("../ads-growth/ads-service/config/adEligiblePaidStoryIds");
// Checks if the wattpad use is a premium user: Premium users do not get ads
var userIsPremium_1 = __importDefault(require("./userIsPremium"));
// Checks if the story is a paid story:  Paid stories do not have ads
var isPaidStory_1 = __importDefault(require("./isPaidStory"));
// Checks if a story is ad exempt (This is set internally by admin tools)
var isAdExemptStory_1 = __importDefault(require("./isAdExemptStory"));
// Some ads placements do not render at all if it fails brand safety.
var isAdvertiserSafe_1 = __importDefault(require("./isAdvertiserSafe"));
var objectIsEmpty = function (object) {
    return (!object ||
        Object.keys(object).length === 0 ||
        Object.getPrototypeOf(object) !== Object.prototype);
};
var includeAdMarkup = function (placement, testGroups, context) {
    var user = context === null || context === void 0 ? void 0 : context.user;
    var story = context === null || context === void 0 ? void 0 : context.story;
    var storyPart = context === null || context === void 0 ? void 0 : context.storyPart;
    // user
    if (typeof user !== "undefined") {
        if (objectIsEmpty(user)) {
            console.error("unexpected user object: ", user);
            return { result: false, reason: "skipped_error_user_object" };
        }
        // premium user check
        if ((0, userIsPremium_1.default)(user))
            return { result: false, reason: "skipped_premium_user" };
    }
    // story part
    if (typeof storyPart !== "undefined") {
        if (objectIsEmpty(storyPart)) {
            console.error("unexpected story part object: ", story);
            return { result: false, reason: "error_with_story_part_object" };
        }
    }
    // story group
    if (typeof story !== "undefined") {
        if (objectIsEmpty(story)) {
            console.error("unexpected story object: ", story);
            return { result: false, reason: "skipped_error_story_object" };
        }
        var inList = (testGroups === null || testGroups === void 0 ? void 0 : testGroups.ADS_IN_WATTPAD_ORIGINALS) &&
            adEligiblePaidStoryIds_1.AD_ELIGIBLE_PAID_STORY_IDS.includes(story === null || story === void 0 ? void 0 : story.id);
        // paid story check
        if ((0, isPaidStory_1.default)(story) && !inList)
            return { result: false, reason: "skipped_paid_story" };
        if ((0, isAdExemptStory_1.default)(story))
            return { result: false, reason: "skipped_ad_exempt_story" };
    }
    // Temp Fix due to inconsistencies
    var storyLandingPlacements = [
        adPlacements_1.adPlacements.STORY_LANDING_TOP,
        adPlacements_1.adPlacements.STORY_LANDING_BOTTOM,
        adPlacements_1.adPlacements.STORY_LANDING_BOTTOM_MWEB,
    ];
    if (!storyLandingPlacements.includes(placement)) {
        var adSafe = (0, isAdvertiserSafe_1.default)(placement, testGroups, context);
        if (!adSafe.result) {
            return {
                result: false,
                reason: adSafe.reason,
            };
        }
    }
    return { result: true, reason: "passes_all_rules" };
};
exports.default = includeAdMarkup;
